export  var ProjectTypeModel =  {
  delivery:'delivery',
  marketPlace:'marketplace'
}